<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar clientes">
  <div leftContent>
    <button pButton 
      label="Cadastrar Cliente" 
      icon="pi pi-plus" 
      (click)="openNew()"
      class="p-button-primary add-button">
    </button>
  </div>
</app-toolbar-search>

<p-table #dt 
  [value]="clientes" 
  [globalFilterFields]="['nome', 'cpfCnpj', 'email', 'telefone']"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [loading]="false"
  [rowsPerPageOptions]="[5, 10, 20, 50]">
  
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="apelido">Nome <p-sortIcon field="apelido"></p-sortIcon></th>
      <th>CPF/CNPJ</th>
      <th pSortableColumn="telefone">Telefone <p-sortIcon field="telefone"></p-sortIcon></th>
      <th>Email</th>
      <th class="text-center">Ações</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-cliente>
    <tr>
      <td>
        <div class="name-content">
          <i class="pi pi-user name-icon"></i>
          <span class="name-text" [pTooltip]="cliente.apelido" tooltipPosition="top">{{cliente.apelido}}</span>
        </div>
      </td>
      <td>
        <div class="document-content">
          <i class="pi pi-id-card document-icon"></i>
          <span class="document-text" [pTooltip]="formatarCpfCnpj(cliente.cpfCnpj)" tooltipPosition="top">{{formatarCpfCnpj(cliente.cpfCnpj)}}</span>
        </div>
      </td>
      <td>
        <div class="phone-content">
          <i class="pi pi-phone phone-icon"></i>
          <span class="phone-text" [pTooltip]="formatarTelefone(cliente.telefone)" tooltipPosition="top">{{formatarTelefone(cliente.telefone)}}</span>
        </div>
      </td>
      <td>
        <div class="email-content">
          <i class="pi pi-envelope email-icon"></i>
          <span class="email-text" [pTooltip]="cliente.email" tooltipPosition="top">{{cliente.email}}</span>
        </div>
      </td>
      <td class="text-center">
        <div class="actions-content">
          <button pButton 
            icon="pi pi-eye" 
            class="p-button-rounded p-button-info action-button"
            (click)="viewDetails(cliente)"
            pTooltip="Ver Detalhes"
            tooltipPosition="top">
          </button>
          <button pButton 
            icon="pi pi-pencil" 
            class="p-button-rounded p-button-warning action-button"
            [routerLink]="['/clientes/editar', cliente.id]"
            pTooltip="Editar Cliente"
            tooltipPosition="top">
          </button>
          <button pButton 
            icon="pi pi-trash" 
            class="p-button-rounded p-button-danger action-button"
            (click)="deleteCliente(cliente)"
            pTooltip="Excluir Cliente"
            tooltipPosition="top">
          </button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-users" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum cliente encontrado</h3>
          <p>Não há clientes cadastrados no sistema.</p>
          <button pButton 
            label="Cadastrar Primeiro Cliente" 
            icon="pi pi-plus" 
            (click)="openNew()" 
            class="p-button-raised">
          </button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>

<p-dialog
  [(visible)]="detailsDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  header="Detalhes do Cliente"
  styleClass="app-detail-dialog"
  [style]="{ width: '90vw', maxWidth: '900px' }"
  [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">
  <app-clientes-detalhes *ngIf="selectedCliente" [cliente]="selectedCliente" (close)="detailsDialogVisible = false"></app-clientes-detalhes>
  <ng-template pTemplate="footer">
    <button pButton label="Fechar" icon="pi pi-times" class="p-button-secondary" (click)="detailsDialogVisible = false"></button>
  </ng-template>
</p-dialog>
